// extracted by mini-css-extract-plugin
export default {"list":"styles_list__fcAjg","listItemPresent":"styles_listItemPresent__uwYY0","text":"styles_text__piMPR","listItemNotPresent":"styles_listItemNotPresent__JBSdK"};